import React from 'react';

// Main component that can handle all legal pages
export default function LegalPageLayout({ pageType = 'terms', companyName = 'Texpidea Technologies Pvt. Ltd.' }) {
  
  const getPageConfig = (type) => {
    const configs = {
      terms: {
        title: 'Terms & Conditions',
        icon: '📋',
        color: 'blue',
        gradient: 'from-blue-500 to-indigo-600',
        bgGradient: 'from-blue-50 to-indigo-50',
        sections: [
          {
            id: '1',
            title: 'Introduction',
            icon: '📝',
            content: (
              <div className="space-y-4">
                <p className="text-gray-700 leading-relaxed">
                  This document is an electronic record in terms of Information Technology Act, 2000 and rules there under as applicable and the amended provisions pertaining to electronic records in various statutes as amended by the Information Technology Act, 2000. This electronic record is generated by a computer system and does not require any physical or digital signatures.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  This document is published in accordance with the provisions of Rule 3 (1) of the Information Technology (Intermediaries guidelines) Rules, 2011 that require publishing the rules and regulations, privacy policy and Terms of Use for access or usage of domain name  including the related mobile site and mobile application (hereinafter referred to as "Platform").
                </p>
                <div className="bg-red-50 border border-red-200 p-4 rounded-lg">
                  <p className="text-red-800 font-semibold">
                    ACCESSING, BROWSING OR OTHERWISE USING THE PLATFORM INDICATES YOUR AGREEMENT TO ALL THE TERMS AND CONDITIONS UNDER THESE TERMS OF USE, SO PLEASE READ THE TERMS OF USE CAREFULLY BEFORE PROCEEDING.
                  </p>
                </div>
                <p className="text-gray-700 leading-relaxed">
                  Your use of the Platform and services and tools are governed by the following terms and conditions ("Terms of Use") as applicable to the Platform including the applicable policies which are incorporated herein by way of reference.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  By mere use of the Platform, You shall be contracting with the Platform Owner and these terms and conditions including the policies constitute Your binding obligations, with Platform Owner.
                </p>
              </div>
            )
          },
          {
            id: '2',
            title: 'User Account and Responsibilities',
            icon: '👤',
            content: (
              <div className="space-y-4">
                <div className="bg-blue-50 p-4 rounded-lg border-l-4 border-blue-400">
                  <p className="text-blue-800 leading-relaxed">
                    To access and use the Services, you agree to provide true, accurate and complete information to us during and after registration, and you shall be responsible for all acts done through the use of your registered account on the Platform. You are responsible for maintaining the confidentiality of your account and password and for restricting access to your computer.
                  </p>
                </div>
                <p className="text-gray-700 leading-relaxed">
                  Your use of our Services and the Platform is solely and entirely at your own risk and discretion for which we shall not be liable to you in any manner. You are required to independently assess and ensure that the Services meet your requirements.
                </p>
                <div className="bg-yellow-50 border border-yellow-200 p-4 rounded-lg">
                  <p className="text-yellow-800 font-medium">
                    You agree not to use the Platform and/ or Services for any purpose that is unlawful, illegal or forbidden by these Terms, or Indian or local laws that might apply to you.
                  </p>
                </div>
              </div>
            )
          },
          {
            id: '3',
            title: 'Intellectual Property Rights',
            icon: '©️',
            content: (
              <div className="bg-gradient-to-r from-purple-50 to-pink-50 p-6 rounded-lg border border-purple-200">
                <p className="text-purple-800 leading-relaxed">
                  The contents of the Platform and the Services are proprietary to us and are licensed to us. This includes and is not limited to the design, layout, look and graphics. You will not have any authority to claim any intellectual property rights, title, or interest in its contents. Unauthorized use of the Platform and/or the Services may lead to action against you as per these Terms of Use and/or applicable laws.
                </p>
              </div>
            )
          },
          {
            id: '4',
            title: 'Limitation of Liability and Indemnification',
            icon: '⚖️',
            content: (
              <div className="space-y-4">
                <div className="bg-orange-50 p-4 rounded-lg border-l-4 border-orange-400">
                  <p className="text-orange-800 leading-relaxed">
                    In no event will the Platform Owner be liable for any indirect, consequential, incidental, special or punitive damages... exceeding the amount paid by You for using the Services giving rise to the cause of action or Rupees One Hundred (Rs. 100) whichever is less.
                  </p>
                </div>
                <p className="text-gray-700 leading-relaxed">
                  You shall indemnify and hold harmless Platform Owner, its affiliates, group companies (as applicable) and their respective officers, directors, agents, and employees, from any claim or demand, or actions including reasonable attorneys' fees, made by any third party or penalty imposed due to or arising out of Your breach of this Terms of Use, privacy Policy and other Policies, or Your violation of any law, rules or regulations or the rights (including infringement of intellectual property rights) of a third party.
                </p>
              </div>
            )
          },
          {
            id: '5',
            title: 'Termination',
            icon: '🔚',
            content: (
              <div className="bg-red-50 p-4 rounded-lg border border-red-200">
                <p className="text-red-800 leading-relaxed">
                  We may suspend or terminate your use of the Website or any Service if we believe, in our sole and absolute discretion that you have breached, violated, abused, or unethically manipulated or exploited any term of these Terms or anyway otherwise acted unethically. Notwithstanding anything in this section, these Terms will survive indefinitely unless and until we choose to terminate them.
                </p>
              </div>
            )
          },
          
          {
            id: '6',
            title: 'Contact Information',
            icon: '📞',
            content: (
              <div className="bg-gradient-to-r from-green-50 to-teal-50 p-6 rounded-lg border border-green-200">
                <p className="text-green-800 leading-relaxed">
                  All concerns or communications relating to these Terms must be communicated to us using the contact information provided on this website. <a 
  href="https://www.texpidea.com" 
  target="_blank" 
  rel="noopener noreferrer"
  
>
  <strong>www.texpidea.com</strong>
</a>

                </p>
              </div>
            )
          }
        ]
      },
      privacy: {
        title: 'Privacy Policy',
        icon: '🛡️',
        color: 'purple',
        gradient: 'from-purple-500 to-blue-600',
        bgGradient: 'from-purple-50 to-blue-50',
        sections: [
          {
            id: '1',
            title: 'Information We Collect',
            icon: '👁️',
            content: (
              <div className="space-y-4">
                <p className="mb-4 text-gray-600">We may collect and process the following data about you:</p>
                <div className="grid gap-4">
                  <div className="bg-blue-50 p-4 rounded-lg border-l-4 border-blue-400">
                    <h4 className="font-semibold text-blue-800 mb-2">Personal Information</h4>
                    <p className="text-blue-700">We collect personal details such as your name, email address, shipping address, phone number, and payment information when you make a purchase, create an account, or contact us.</p>
                  </div>
                  <div className="bg-green-50 p-4 rounded-lg border-l-4 border-green-400">
                    <h4 className="font-semibold text-green-800 mb-2">Non-Personal Information</h4>
                    <p className="text-green-700">We may collect non-personal data such as browser type, operating system, IP address, and browsing behavior to improve our website and services.</p>
                  </div>
                  <div className="bg-yellow-50 p-4 rounded-lg border-l-4 border-yellow-400">
                    <h4 className="font-semibold text-yellow-800 mb-2">Cookies</h4>
                    <p className="text-yellow-700">Our website uses cookies to distinguish you from other users of our website. This helps us to provide you with a good experience when you browse our website and also allows us to improve our site.</p>
                  </div>
                </div>
              </div>
            )
          }
          // Add more privacy sections here...
        ]
      },
      refund: {
        title: 'Refund Policy',
        icon: '💰',
        color: 'green',
        gradient: 'from-green-500 to-emerald-600',
        bgGradient: 'from-green-50 to-emerald-50',
        sections: [
          {
            id: '1',
            title: 'Refund Options',
            icon: '💳',
            content: (
              <div className="space-y-6">
                <p className="text-gray-700 text-lg mb-6">
                  Please review our refund policy options below. The applicable policy is determined by the nature of the service or product you have purchased.
                </p>
                
                <div className="grid gap-6 md:grid-cols-2">
                  <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow border-t-4 border-green-400">
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                        <span className="text-2xl">✅</span>
                      </div>
                      <h3 className="text-xl font-semibold text-green-800">Option 1: Approved Refunds</h3>
                    </div>
                    <div className="bg-green-50 p-4 rounded-lg border border-green-200">
                      <p className="text-green-700 font-medium mb-2">Processing Time:</p>
                      <p className="text-green-800">
                        Once the refund is approved, it will take <strong className="text-green-900">7 business days</strong> to credit to your bank account.
                      </p>
                    </div>
                  </div>

                  <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow border-t-4 border-red-400">
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
                        <span className="text-2xl">❌</span>
                      </div>
                      <h3 className="text-xl font-semibold text-red-800">Option 2: No Refund Services</h3>
                    </div>
                    <div className="bg-red-50 p-4 rounded-lg border border-red-200">
                      <p className="text-red-700 font-medium mb-2">Service Policy:</p>
                      <p className="text-red-800">
                        For our services, <strong className="text-red-900">we don't entertain refunds</strong>.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 rounded-xl border border-blue-200 mt-8">
                  <div className="flex items-center gap-3 mb-4">
                    <span className="text-2xl">ℹ️</span>
                    <h4 className="text-lg font-semibold text-blue-800">Important Information</h4>
                  </div>
                  <ul className="text-blue-700 space-y-2">
                    <li className="flex items-start gap-2">
                      <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                      <span>Refund eligibility depends on the specific terms of your purchase</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                      <span>All refund requests must be submitted through our official channels</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
                      <span>Processing times may vary based on your bank's policies</span>
                    </li>
                  </ul>
                </div>
              </div>
            )
          }
        ]
      }
    };
    return configs[type] || configs.terms;
  };

  const config = getPageConfig(pageType);

  return (
    <div className={`min-h-screen bg-gradient-to-br ${config.bgGradient}`}>
      {/* Header */}
      <div className="bg-white shadow-lg">
        <div className="max-w-4xl mx-auto px-6 py-12">
          <div className="flex items-center gap-4 mb-6">
            <div className={`w-16 h-16 bg-gradient-to-br ${config.gradient} rounded-2xl flex items-center justify-center shadow-lg`}>
              <span className="text-3xl">{config.icon}</span>
            </div>
            <div>
              <h1 className={`text-4xl font-bold bg-gradient-to-r ${config.gradient} bg-clip-text text-transparent`}>
                {config.title}
              </h1>
              <p className="text-gray-600 mt-2">Last Updated: 24 September 2025</p>
            </div>
          </div>
          
          {pageType !== 'refund' && (
            <div className="bg-gradient-to-r from-blue-50 to-purple-50 p-6 rounded-xl border border-blue-200">
              <p className="text-gray-700 leading-relaxed">
                This website is Owned & Operated by <strong className="text-blue-600">{companyName}</strong>. 
                {pageType === 'privacy' ? 
                  ' We are committed to protecting your privacy and ensuring that your personal information is handled in a safe and responsible manner.' :
                  ' These terms and conditions govern your use of our platform and services.'
                }
              </p>
            </div>
          )}
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="space-y-12">
          {config.sections.map((section) => (
            <div key={section.id} className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow p-8">
              <div className="flex items-center gap-4 mb-6">
                <div className={`w-12 h-12 bg-gradient-to-br ${config.gradient} rounded-xl flex items-center justify-center text-white shadow-md`}>
                  <span className="text-xl">{section.icon}</span>
                </div>
                <h2 className="text-2xl font-bold text-gray-800">
                  {section.id}. {section.title}
                </h2>
              </div>
              <div className="ml-16">
                {section.content}
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-2 px-6 py-3 bg-white rounded-full shadow-lg">
            <span className="text-2xl">{config.icon}</span>
            <span className="text-gray-600 font-medium">
              {pageType === 'privacy' ? 'Your privacy is our priority' :
               pageType === 'refund' ? 'Fair and transparent refund policy' :
               'Terms you can understand'}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

